import AxiosClient from "../../../servicesAcept/axios.services";

class EvaluationAcceptServices {
  getEvaluationAccept = (token) =>
    AxiosClient.get("/api/app/evaluacion_Empleado_Aceptacion_Evaluacion/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });
  getEvaluationAcceptById = (id, token) =>
    AxiosClient.get(
      `/api/app/evaluacion_Empleado_Aceptacion_Evaluacion/${id}/`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      }
    );
  saveEvaluationAccept = (data, token) =>
    AxiosClient.post(
      `/api/app/evaluacion_Empleado_Aceptacion_Evaluacion/`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      }
    );
  editEvaluationAccept = (id, data, token) =>
    AxiosClient.put(
      `/api/app/evaluacion_Empleado_Aceptacion_Evaluacion/${id}/`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      }
    );
}

export default new EvaluationAcceptServices();
